<template>
  <div class="saturday-roster-day height-100 flex-col">

    <div class="flex">
      <div class="flex-1 bold font-size-150">{{ title }}</div>
      <button class="button is-small" @click="showHistory = true"><fa icon="clock" /></button>
    </div>

    <div class="pad">
      <p v-if="day.user" class="b font-size-120">{{ day.user.firstName }} {{ day.user.lastName }}</p>
      <template v-if="day.swapRequestUser">
        <p class="font-size-70">swap requested</p>
        <p class="bold">{{ day.swapRequestUser.firstName }} {{ day.swapRequestUser.lastName }}</p>
      </template>
      <h2 v-if="!day.user" class="title is-4 has-text-grey-light">
        {{ day.closed ? 'CLOSED' : 'NO ONE ROSTERED ON' }}
      </h2>
    </div>

    <template v-if="showHistory">
      <div class="pad-5 bg-eee bold border-ccc margin-bottom-5">HISTORY</div>
      <div class="flex-1 overflow-y-scroll border-ccc margin-bottom">
        <table class="table is-striped is-hoverable" v-if="day.history && day.history">
          <tbody>
            <tr v-for="h in day.history" :key="h.timestamp">
              <td>
                <p class="bold">{{ h.timestamp | unixToDateTimeString}}</p>
                <p class="font-size-80 i">{{ h.user.firstName }} {{ h.user.lastName }}</p>
              </td>
              <td>
                <p class="b">{{ h.action }}</p>
                <p v-if="h.rosteredUser">{{ h.rosteredUser.firstName }} {{ h.rosteredUser.lastName }}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="bold pad center has-text-grey-light" v-if="!day.history || !day.history">NO HISORY</div>
      </div>
    </template>
    <template v-else-if="userAction">
      <b-input v-model="serachStr" placeholder="search user" />
      <div class="flex-1 overflow-y-scroll border-ccc margin-bottom margin-top-5">
        <table class="table is-striped is-hoverable">
          <tbody>
            <tr v-for="user in filteredUsers" :key="user._id" @click="onUserSelect(user)">
              <th class="nowrap" style="width: 10px">{{ user.firstName }} {{ user.lastName }}</th>
              <td class="left">
                <button v-if="!day.user || day.user._id !== user._id" class="button is-small" :class="{'is-loading': user._id === loadingId}">{{ userAction }}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-else>
      <!-- TO SPACE OUT VERTICALLY -->
      <div class="flex-1"></div>
    </template>

    <template v-if="!showHistory">
      <div class="buttons">
        <button class="button" @click="$emit('close')">Close</button>

        <button v-if="canRequestSwap" class="button" @click="userAction = 'Request Swap'">Request Swap</button>
        <button v-if="userAction === 'Request Swap'" class="button" @click="userAction = null">Cancel Swap Request</button>

        <button v-if="canRemoveSwapRequest" class="button" @click="onRemoveSwapRequest()">Remove Swap Request</button>
        <button v-if="canRejectSwapRequest" class="button" @click="onRejectSwapRequest()">Reject Swap Request</button>
      </div>

      <!-- ADMIN BUTTONS -->
      <template v-if="showAdminOptions">
        <div class="font-size-70" style="margin-top: -15px">ADMIN OPTIONS</div>
        <div class="buttons" v-if="isAdmin">
          <button v-if="!userAction && !day.user && !day.closed" class="button" @click="userAction = 'Roster On'">Roster On</button>
          <button v-if="userAction === 'Roster On'" class="button" @click="userAction = null">Cancel Roster On</button>

          <button v-if="!userAction && !day.user && !day.closed" class="button is-danger" :class="{'is-loading': loadingId === 'closed'}" @click="submitClosed()">Closed</button>
          <button v-if="!userAction && !day.user && day.closed" class="button is-info" :class="{'is-loading': loadingId === 'open'}" @click="submitOpen()">Open</button>

          <button v-if="!userAction && day.user" class="button" @click="userAction = 'Swap'">Swap</button>
          <button v-if="userAction === 'Swap'" class="button" @click="userAction = null">Cancel Swap</button>

          <button v-if="adminCanRemoveSwapRequest" class="button" @click="onRemoveSwapRequest()">Remove Swap Request</button>

          <button v-if="adminCanRequestSwap" class="button" @click="userAction = 'Request Swap'">Request Swap</button>

          <button v-if="day.user" class="button is-danger" :class="{'is-loading': loadingId === 'clear'}" @click="submitClear()">Clear</button>
        </div>
      </template>

    </template>
    <template v-else>
      <div class="buttons">
        <button class="button" @click="showHistory = false">Close History</button>
      </div>
    </template>

  </div>
</template>

<script>
export default {
  name: 'SaturdayRosterDay',
  props: {
    day: { requred: true }
  },
  data () {
    return {
      users: null,
      userAction: null,
      serachStr: '',
      showHistory: false,
      loadingId: null
    }
  },
  computed: {
    user () { return this.$store.getters.user },
    isAdmin () { return this.user && this.user.privileges.includes('saturday roster admin') },
    title () { return this.$moment.unix(this.day.timestamp).format('dddd DD/MM/YYYY') },
    canRequestSwap () {
      if (this.userAction || this.day.swapRequestUser) return false
      if (this.day.user && this.day.user._id === this.user._id) return true
      return false
    },
    canRemoveSwapRequest () {
      if (this.userAction || !this.day.swapRequestUser) return false
      if (this.day.user && this.day.user._id === this.user._id) return true
    },
    canRejectSwapRequest () {
      if (this.userAction || !this.day.swapRequestUser) return false
      if (this.day.swapRequestUser._id === this.user._id) return true
      return false
    },
    showAdminOptions () {
      if (!this.isAdmin) return false
      return true
    },
    adminCanRequestSwap () {
      if (this.userAction || !this.isAdmin || this.canRequestSwap) return false
      if (this.day.user && !this.day.swapRequestUser) return true
      return false
    },
    adminCanRemoveSwapRequest () {
      if (this.userAction || !this.isAdmin || this.canRemoveSwapRequest) return false
      if (this.day.swapRequestUser) return true
      return false
    },
    filteredUsers () {
      let str = this.serachStr.trim().toLowerCase()
      if (!str.length) return this.users || []
      return this.users.filter(u => {
        return u.firstName.toLowerCase().indexOf(str) === 0 ||
          u.lastName.toLowerCase().indexOf(str) === 0
      })
    }
  },
  watch: {
    day () { this.prepareDay() }
  },
  created () {
    this.prepareDay()
    this.subs.users = this.$firestore.collection('users')
      .where('privileges', 'array-contains', 'saturday roster')
      .onSnapshot(snapshot => {
        this.users = this.$utils.snapshotToArr(snapshot)
      })
  },
  methods: {
    prepareDay () {
      this.userAction = null
      if (!this.day.history) this.day.history = []
      // if (!this.day.user) {
      //   this.userAction = 'Roster On'
      // } else {
      //   this.userAction = null
      // }
    },
    async onUserSelect (selectedUser) {
      if (this.day.user && this.day.user._id === selectedUser._id) {
        return
      }

      this.loadingId = selectedUser._id

      if (this.userAction === 'Roster On') {
        await this.submitRosterOn(selectedUser)
      } else if (this.userAction === 'Swap') {
        await this.submitSwap(selectedUser)
      } else if (this.userAction === 'Request Swap') {
        await this.submitRequestSwap(selectedUser)
      }
      this.loadingId = null
    },
    async submitRequestSwap (selectedUser) {
      let confirmed = await this.$confirm({
        type: 'is-danger',
        title: 'Confirm Swap',
        confirmText: 'REQUEST SWAP',
        message: `
          <p>Are you sure you want to request to swap out of this shift with</p>
          <p class="b">${selectedUser.firstName} ${selectedUser.lastName}<p>
        `
      })
      if (!confirmed) return

      let userData = this.getUserData(selectedUser)
      let day = this.$utils.clone(this.day)
      day.swapRequestUser = userData
      day.history.push({
        timestamp: this.$moment().unix(),
        action: 'Request Swap',
        rosteredUser: userData,
        user: this.getUserData(this.user)
      })

      await this.$firestore.collection('saturdayRosterDays')
        .doc(`${day.timestamp}`)
        .set(day)
      this.$emit('close')
    },
    async submitSwap (selectedUser) {
      let confirmed = await this.$confirm({
        type: 'is-danger',
        title: 'Confirm Swap',
        confirmText: 'SWAP',
        message: `
          <p>from</p>
          <p class="b">${this.day.user.firstName} ${this.day.user.lastName}<p>
          <p>to</p>
          <p class="b">${selectedUser.firstName} ${selectedUser.lastName}<p>
        `
      })
      if (!confirmed) return

      let userData = this.getUserData(selectedUser)
      let day = this.$utils.clone(this.day)
      day.user = userData
      day.swapRequestUser = null
      day.history.push({
        timestamp: this.$moment().unix(),
        action: 'Swap',
        rosteredUser: userData,
        user: this.getUserData(this.user)
      })

      await this.$firestore.collection('saturdayRosterDays')
        .doc(`${day.timestamp}`)
        .set(day)
      this.$emit('close')
    },
    async submitRosterOn (selectedUser) {
      let userData = this.getUserData(selectedUser)
      let day = this.$utils.clone(this.day)
      day.user = userData
      day.history.push({
        timestamp: this.$moment().unix(),
        action: this.userAction,
        rosteredUser: userData,
        user: this.getUserData(this.user)
      })
      await this.$firestore.collection('saturdayRosterDays')
        .doc(`${day.timestamp}`)
        .set(day)
      this.$emit('close')
    },
    async onRemoveSwapRequest () {
      let confirmed = await this.$confirm({
        type: 'is-danger',
        title: 'Remove Swap Request',
        confirmText: 'REMOVE',
        message: `
          <p>Are you sure you want to remove the swap request with</p>
          <p class="b">${this.day.swapRequestUser.firstName} ${this.day.swapRequestUser.lastName}<p>
        `
      })
      if (!confirmed) return

      let day = this.$utils.clone(this.day)
      day.history.push({
        timestamp: this.$moment().unix(),
        action: 'Remove Swap Request',
        rosteredUser: day.swapRequestUser,
        user: this.getUserData(this.user)
      })
      day.swapRequestUser = null
      await this.$firestore.collection('saturdayRosterDays')
        .doc(`${day.timestamp}`)
        .set(day)
      this.$emit('close')
    },
    async onRejectSwapRequest () {
      let confirmed = await this.$confirm({
        type: 'is-danger',
        title: 'Reject Swap Request',
        confirmText: 'REJECT',
        message: `
          <p>Are you sure you want to reject this swap requested</p>
        `
      })
      if (!confirmed) return

      let day = this.$utils.clone(this.day)
      day.history.push({
        timestamp: this.$moment().unix(),
        action: 'Reject Swap Request',
        rosteredUser: day.swapRequestUser,
        user: this.getUserData(this.user)
      })
      day.swapRequestUser = null
      await this.$firestore.collection('saturdayRosterDays')
        .doc(`${day.timestamp}`)
        .set(day)
      this.$emit('close')
    },
    async submitClosed () {
      let confirmed = await this.$confirm({
        type: 'is-danger',
        title: 'Confirm Closed',
        confirmText: 'CLOSED',
        message: `<p>Are you sure you want to set ${this.$moment.unix(this.day.timestamp).format('dddd DD/MM/YYYY')} as closed?</p>`
      })
      if (!confirmed) return

      this.loadingId = 'closed'

      let day = this.$utils.clone(this.day)
      day.history.push({
        timestamp: this.$moment().unix(),
        action: 'Closed',
        rosteredUser: null,
        user: this.getUserData(this.user)
      })
      day.user = null
      day.swapRequestUser = null
      day.closed = true
      await this.$firestore.collection('saturdayRosterDays')
        .doc(`${day.timestamp}`)
        .set(day)
      this.$emit('updated', day, 'close')
      this.loadingId = null
    },
    async submitOpen () {
      let confirmed = await this.$confirm({
        type: 'is-info',
        title: 'Confirm Open',
        confirmText: 'OPEN',
        message: `<p>Are you sure you want to set ${this.$moment.unix(this.day.timestamp).format('dddd DD/MM/YYYY')} as open?</p>`
      })
      if (!confirmed) return

      this.loadingId = 'open'

      let day = this.$utils.clone(this.day)
      day.history.push({
        timestamp: this.$moment().unix(),
        action: 'Open',
        rosteredUser: null,
        user: this.getUserData(this.user)
      })
      day.user = null
      day.swapRequestUser = null
      day.closed = false
      await this.$firestore.collection('saturdayRosterDays')
        .doc(`${day.timestamp}`)
        .set(day)
      this.$emit('updated', day, 'open')
      this.loadingId = null
    },
    async submitClear () {
      let confirmed = await this.$confirm({
        type: 'is-danger',
        title: 'Confirm Clear',
        confirmText: 'CLEAR',
        message: `
          <p>Clearing</p>
          <p class="b">${this.day.user.firstName} ${this.day.user.lastName}<p>
        `
      })
      if (!confirmed) return

      this.loadingId = 'clear'

      let day = this.$utils.clone(this.day)
      day.history.push({
        timestamp: this.$moment().unix(),
        action: 'Clear',
        rosteredUser: day.user,
        user: this.getUserData(this.user)
      })
      day.user = null
      day.swapRequestUser = null
      await this.$firestore.collection('saturdayRosterDays')
        .doc(`${day.timestamp}`)
        .set(day)
      this.$emit('updated', day, 'clear')
      this.loadingId = null
    },
    getUserData (user) {
      return {
        _id: user._id,
        firstName: user.firstName,
        lastName: user.lastName
      }
    }
  }
}
</script>
